import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { IKeyValue } from '../../modules/models/common-model';
import * as fromsmryModels from '../../modules/models/supervision-model';
import { Utils } from '../../modules/shared/utils';

@Component({
  selector: 'app-report-view-by-type',
  standalone: false,
  templateUrl: './report-view-by-type.html',
  styleUrl: './report-view-by-type.scss'
})
export class ReportViewByType {
@Input('summaryResponse') summaryResponse: fromsmryModels.SmryByRptType[] | undefined;
@Input('selectedYear') selectedYear: number = 0;
@Input('alertDescriptions') alertDescriptions: string[] = [];
@Input('alertColorMap') alertColorMap: { [groupCode: string]: { [alertDesc: string]: string } } = {};
@Input('reportRole') reportRole: string = '';
@Input('reportTypes') reportTypes: IKeyValue[] = [];

  constructor(private router: Router) {}

  getOpenCount(item: any, desc: string): number | string {
    return Utils.getOpenCount(item, desc);
  }

  getTypeOpenCount(rptType: any, desc: string): number | string {
    if (!rptType?.smryItems?.length) return '-';
    const field = Utils.OPEN_FIELD_MAP[desc];
    if (!field) return '-';
    let total = 0;
    for (const item of rptType.smryItems) {
      const val = item[field] ?? item[field.toLowerCase()];
      if (val !== undefined && val !== null) total += val;
    }
    return total === 0 ? '--' : total;
  }

  zeroAsDash(value: number | string | null | undefined): number | string {
    return Utils.zeroAsDash(value);
  }

  goToSupervisionReport(rptType: string, year: number, month: number, event: Event, alertDescription?: string): void {
    Utils.goToSupervisionReport(this.router, rptType, year, month, event, alertDescription, this.reportRole, this.reportTypes);
  }

  getAlertColor(rptType: string, desc: string, count?: number | string): string {
    return Utils.getAlertColor(this.alertColorMap, rptType, desc, count);
  }
}
